"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var SnackbarContent_1 = __importDefault(require("@mui/material/SnackbarContent"));
var react_1 = require("react");
var CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var useBreakpoints_1 = require("@hooks/useBreakpoints");
var hooks_1 = require("./hooks");
var StyledSnackbarContent = (0, styles_1.styled)(SnackbarContent_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "fit-content",
        minWidth: "auto",
        backgroundColor: "transparent",
        boxShadow: theme.shadows[0],
    });
});
var getIconColor = function (theme, variant) {
    return {
        success: theme.palette.success.dark,
        error: theme.palette.common.white,
        info: theme.palette.info.dark,
        warning: theme.palette.warning.light,
    }[variant];
};
var getStyles = function (theme, variant, isUnderSm) { return ({
    padding: theme.spacing(2),
    boxShadow: theme.shadows[3],
    borderRadius: "8px",
    width: isUnderSm ? "100%" : "fit-content",
    backgroundColor: variant === "error"
        ? theme.palette.error.dark
        : theme.palette.other.snackbarBackground,
    "& .MuiAlert-action button": {
        color: theme.palette.common.white,
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
            backgroundColor: variant === "error" ? theme.palette.red[800] : theme.palette.grey[900],
        },
    },
    "& .MuiAlert-icon svg": {
        color: getIconColor(theme, variant),
    },
}); };
exports.Toast = (0, react_1.forwardRef)(function (_a, ref) {
    var id = _a.id, message = _a.message, variant = _a.variant, onClose = _a.onClose;
    var isUnderSm = (0, useBreakpoints_1.useIsUnderSm)();
    var dismissToast = (0, hooks_1.useToast)().dismissToast;
    var handleDismiss = (0, react_1.useCallback)(function () {
        dismissToast(id);
        if (onClose)
            onClose();
    }, [id, onClose, dismissToast]);
    return ((0, jsx_runtime_1.jsx)(StyledSnackbarContent, { elevation: 3, ref: ref, message: (0, jsx_runtime_1.jsx)(Alert_1.default, { iconMapping: {
                success: (0, jsx_runtime_1.jsx)(CheckCircleOutline_1.default, { fontSize: "inherit" }),
            }, severity: variant, onClose: handleDismiss, sx: function (theme) { return getStyles(theme, variant, isUnderSm); }, children: (0, jsx_runtime_1.jsx)(Typography_1.default, { sx: { fontWeight: "bold", color: "#fff" }, children: message }) }), style: {
            width: isUnderSm ? "100%" : "fit-content",
            minWidth: "auto",
        } }));
});
